import CityPageTemplate from "../city-template/CityPageTemplate";
import { pierreConfig } from "./data";

export default function PierrePage() {
  return <CityPageTemplate config={pierreConfig} />;
}